import React from "react";

import UserIcon from "core/gd-ui/icon/user/user";
import Select from "core/gd-ui/select/text";

export default function ModalAddUserCompanyUsersMeeting(props) {

    const onRoleSelect = (userId, role) => {props.onRoleSelect(userId, role);}
    const onUserClick = (userId, e) => {props.onUserClick(userId, 'company', e)}

    const companyUsers = _.get(props,'companyUsers', [])

    const selectedArr = props.selected.map(obj=>obj.userId)

    const options = [
        {label: 'Participant',  value: gd.const.meeting.role.PARTICIPANT},
        {label: 'Organizer',    value: gd.const.meeting.role.ORGANIZER}
    ];

    return (
        <div className="ui5-manage-list users-with-access multiselect">
            {_.map(companyUsers,(cu, key)=>{
                const isSelected = selectedArr.includes(cu.user.id);

                const classes = Classes('row', {
                    selected: isSelected
                });

                const checkboxClasses = Classes('ui5-cb', 's-16', {
                    selected: isSelected
                });

                const selectedItem = _.find(props.selected, (o)=>o.userId === cu.user.id);

                return (
                    <div className={classes} key={key} onClick={onUserClick.bind(this, cu.user.id)}>
                        <div className="cell center">
                            <div className={checkboxClasses}/>
                        </div>

                        <div className="cell content">
                            <UserIcon userId={cu.user.id} size="26" className="m-r-10" />
                            <div className="user-name">{cu.user.name}</div>
                        </div>
                        <div className="cell">
                            {isSelected &&
                            <div className="role-block">
                                <Select options={options}
                                        renderValue="text-13"
                                        value={selectedItem.role}
                                        onChange={(role)=>{onRoleSelect(cu.user.id, role)}}
                                        underlined="always"/>
                            </div>}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}